<section class="section-container">
  <div class="section-content">
    <div class="installment-info">
      <img [src]="assets.installmentIcon" alt="parcelamento icone">
      <h3 class="hide-on-pf">
        Parcele <strong>sem cartão*</strong> <br/> <span>use o carnê digital</span>
      </h3>
      <h3 class="hide-on-cb">
        Parcele <strong>sem cartão*</strong> <br/> <span>use o carnê da loja</span>
      </h3>
      <button class="hide-on-pf" (click)="handleOpenCarneDigital()" type="button" mat-stroked-button color="primary">
        Comprar com carnê
      </button>
    </div>
  </div>

  <div class="benefits-cards-container">
    <div class="benefits-cards">
      <ul>

        <li>
          <div class="title-container">
            <img [src]="assets.digital" alt="2ª via do Carnê">
            <h3>Tudo na mão e 
              100% Digital</h3>
          </div>
          <div class="item-description">
            <p>
              Resolva sua vida financeira sem ter que ir até uma loja
            </p>
          </div>
        </li>

        <li>
          <div class="title-container">
            <img [src]="assets.pixPayment" alt="2ª via do Carnê">
            <h3>Pague o carnê com Pix</h3>
          </div>
          <div class="item-description">
            <p>
              Pagamento rápido, fácil e seguro
            </p>
          </div>
        </li>

        <li>
          <div class="title-container">
            <img [src]="assets.renegotiation" alt="2ª via do Carnê">
            <h3>Negocie a dívida <br> do cartão</h3>
          </div>
          <div class="item-description">
            <p>
              Condições especiais para negociar nas Casas Bahia
            </p>
          </div>
        </li>

        <li>
          <div class="title-container">
            <img [src]="assets.secondCopy" alt="2ª via do Carnê">
            <h3>Administre seus acordos</h3>
          </div>
          <div class="item-description">
            <p>
              Acompanhe o andamento dos seus acordos e boletos
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</section>